import { mapActions } from 'vuex';

import ResponseUtil from '@/util/response-util';

import canClockTimeEntry from '@/mixins/clocking/clockTimeEntry';

export default {
  mixins: [canClockTimeEntry],

  methods: {
    ...mapActions(['saveShiftTimeEntries']),

    createShiftTimeEntries(unsavedTimeEntries, successCallback, lastly, errorCallback) {
      this.saveShiftTimeEntries(unsavedTimeEntries)
      .then((response) => {
        successCallback(response.data);
      })
      .catch((error) => {
        this.showAppErrorDialog({ message: ResponseUtil.getTimeRequestErrorMessage(error.response) });
        errorCallback(error);
      })
      .finally(() => lastly());
    },
  },
};
